import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import clouds from 'assets/images/import-clouds.svg'

import i18n from 'modules/core/lib/i18n'

import { usePreviewProvider } from 'modules/processes/components/ItemWizard/Providers/preview'

import PreviewAttachments from '../../../../components/Preview/Attachments'
import PreviewDescription from '../../../../components/Preview/Description'
import PreviewTitle from '../../../../components/Preview/Title'

const Preview = () => {
  const { previewValues } = usePreviewProvider()

  return (
    <Box>
      <PreviewTitle />
      <PreviewDescription />
      <PreviewAttachments />
      <Box paddingY="s16">
        <Text.Normal weight="semibold" color="grey1000">
          {i18n.t('processes.process_settings.wizard.tasks.types.upload_document.preview.title')}
        </Text.Normal>

        <Box paddingTop="s8">
          <Text.Normal>
            {i18n.t(
              'processes.process_settings.wizard.tasks.types.upload_document.preview.description',
              { name: previewValues.name }
            )}
          </Text.Normal>
        </Box>

        <Box paddingTop="s12">
          <Box
            width="full"
            textAlign="center"
            borderRadius={{ all: 'abs006' }}
            border={{
              all: {
                width: 's2',
                style: 'dashed',
                color: 'grey400',
              },
            }}
          >
            <Box
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              minHeight="s200"
            >
              <Box paddingBottom="s8">
                <img src={clouds} />
              </Box>
              <Text.Normal>{i18n.t('file_importer.default_placeholder')}</Text.Normal>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Preview
